'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { createFragmentContainer, graphql } = require('react-relay/compat');
const { localStorage, sessionStorage } = require('dibs-browser-storage');
const { currencies } = require('dibs-currency-helpers/constants');
const get = require('lodash.get');

const US_COUNTRY_CODE = 'US';

class AffirmDisplay extends React.Component {
    shouldBeDisplayed() {
        const { viewer, item, user } = this.props;

        // Affirm Checkout is enabled
        const isEnabled = get(viewer, 'isEnabled') || false;

        // Not trade user
        const isUserVerifiedTrade = get(user, 'isVerifiedTrade') || false;

        // Only US IPs
        const isUserIPValid = get(viewer, 'regionalInfo[0].countryCode') === US_COUNTRY_CODE;

        // Currency must be USD
        const userCurrency = user
            ? get(user, 'profile.currency')
            : localStorage.getItem('userCurrency') || sessionStorage.getItem('userCurrency');
        const isUserCurrencyValid = userCurrency === currencies.CURRENCY_USD;

        // Item is eligible
        const isItemEligible = get(item, 'displayInfo.showAffirmPromo') || false;

        return (
            isEnabled &&
            !isUserVerifiedTrade &&
            isUserIPValid &&
            isUserCurrencyValid &&
            isItemEligible
        );
    }

    render() {
        if (!this.shouldBeDisplayed()) {
            return null;
        }

        return this.props.children;
    }
}

AffirmDisplay.propTypes = {
    children: PropTypes.node,
    viewer: PropTypes.object,
    item: PropTypes.object,
    user: PropTypes.object,
};

module.exports = createFragmentContainer(AffirmDisplay, {
    user: graphql`
        fragment AffirmDisplay_user on User {
            profile {
                currency
            }
            isVerifiedTrade
        }
    `,
    item: graphql`
        fragment AffirmDisplay_item on Item {
            displayInfo {
                showAffirmPromo
            }
        }
    `,
    viewer: graphql`
        fragment AffirmDisplay_viewer on Viewer {
            isEnabled(key: "affirmCheckout")
            regionalInfo {
                countryCode
            }
        }
    `,
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Affirm/AffirmDisplay.jsx